import { Expression, Literal } from '../models/expressionTypes';
import { ExpressionVisitor } from './expression.visitor';
import { AssertPlainObject } from '../plainObjects/assert.plainObject';
import { AssertExpressionPlainObject } from '../plainObjects/assertExpression.plainObject';
import { BaseTransformationVisitor } from './baseTransformation.visitor';

export class AssertVisitor extends BaseTransformationVisitor {
    private get _assertTransformation(): AssertPlainObject {
        return this.transformation as AssertPlainObject;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitBasicFunction(context: any): void {
        const assertExpression = new AssertExpressionPlainObject();
        const expressions = context.expression();
        assertExpression.assertType = this._getText(context.basicName());
        switch (assertExpression.assertType) {
            case 'expectTrue':
                assertExpression.trueExpression = expressions[0] ? this._getText(expressions[0]) : '';
                assertExpression.ignoreNulls = expressions[1] && this._getText(expressions[1]) === 'true';
                assertExpression.assertId = expressions[2] ? this._getText(expressions[2]) : '';
                if (expressions[3]) {
                    const text = this._getText(expressions[3]);
                    assertExpression.filter = text !== 'null' ? text : '';
                }
                assertExpression.assertDescription = expressions[4] ? this._getText(expressions[4]) : '';
            break;
            case 'expectUnique':
                assertExpression.uniqueExpressions = [];
                let i = 0;
                let curr: Expression;
                let next: Expression;
                let foundIgnoreNulls = false;
                // expressions will come in as expectUnique(exp1, exp2, exp3, ..., expN, ignoreNulls, assertId, filter, assertDescription)
                // uniqueExpressions and ignoreNulls appear to have same type of ColumnOperand so we will look for assertId to know which is which
                // we know that ignoreNulls will show before assertId which will have value of type Literal
                const expressionVisitor = new ExpressionVisitor(this._tokenStream);
                while (!foundIgnoreNulls && i < expressions.length - 1) {
                    curr =  expressionVisitor.visit(expressions[i]);
                    next =  expressionVisitor.visit(expressions[i + 1]);
                    if (next.value instanceof Literal) {
                        foundIgnoreNulls = true;
                        assertExpression.ignoreNulls = curr.text === 'true';
                    } else {
                        assertExpression.uniqueExpressions.push(curr.text);
                    }
                    i++;
                }
                curr =  expressionVisitor.visit(expressions[i]);
                next =  i + 1 < expressions.length ? expressionVisitor.visit(expressions[i + 1]) : undefined;
                assertExpression.assertId = curr.text;
                assertExpression.filter = next && next.text !== 'null' ? next.text : '';
                if (i + 2 < expressions.length) {
                    const nextNext: Expression = expressionVisitor.visit(expressions[i + 2]);
                    assertExpression.assertDescription = nextNext ? nextNext.text : '';
                }
            break;
            case 'expectExists':
                assertExpression.existsExpression = expressions[0] ? this._getText(expressions[0]) : '';
                assertExpression.ignoreNulls = expressions[1] && this._getText(expressions[1]) === 'true';
                assertExpression.assertId = expressions[2] ? this._getText(expressions[2]) : '';
                if (expressions[3]) {
                    const text = this._getText(expressions[3]);
                    assertExpression.filter = text !== 'null' ? text : '';
                }
                assertExpression.assertDescription = expressions[4] ? this._getText(expressions[4]) : '';
            break;
            default:
            break;
        }
        this._assertTransformation.asserts.push(assertExpression);
    }
}
